function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var MobileBroadband = function MobileBroadband(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M13.406 1c1.102 0 2 .915 2 2.04v1.932a2 2 0 0 1 1.337 1.887v11.379c0 2.598-2.173 4.711-4.843 4.711s-4.842-2.113-4.842-4.711V6.859c0-.87.559-1.612 1.336-1.887V3.04c0-1.125.897-2.04 2-2.04zm1.337 5.859H9.058v11.379c0 1.495 1.275 2.711 2.842 2.711s2.843-1.216 2.843-2.711zm-11.117.245c.424.354.481.984.128 1.41a5.4 5.4 0 0 0-1.254 3.46c0 1.207.391 2.351 1.131 3.306a.999.999 0 1 1-1.581 1.224 7.33 7.33 0 0 1-1.55-4.53c0-1.729.61-3.413 1.717-4.742a1 1 0 0 1 1.409-.128m17.957.128a7.42 7.42 0 0 1 1.717 4.741 7.33 7.33 0 0 1-1.55 4.531.997.997 0 0 1-1.403.178 1 1 0 0 1-.178-1.402 5.35 5.35 0 0 0 1.131-3.307 5.4 5.4 0 0 0-1.254-3.46 1.001 1.001 0 0 1 1.537-1.28M6.038 8.952a1 1 0 0 1 .077 1.412 2.41 2.41 0 0 0 0 3.22 1 1 0 1 1-1.489 1.334 4.408 4.408 0 0 1 0-5.89 1 1 0 0 1 1.412-.076m13.136.076a4.4 4.4 0 0 1 1.127 2.946c0 1.089-.4 2.134-1.127 2.945a1 1 0 1 1-1.49-1.336 2.407 2.407 0 0 0 0-3.22 1 1 0 0 1 1.49-1.335M10.394 3v1.858h3.011V3.04z"
  }));
};
export default MobileBroadband;